<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-20 15:50:07
 * @LastEditors: mrh
 * @LastEditTime: 2020-09-29 10:22:33
--> 
<template>
  <div class="headercontent">
    <header class="van-hairline--bottom">
      <van-icon
        name="arrow-left return"
        @click="closeHandsel"
        v-show="!headerShow && !$route.meta.iconBackHidden"
      />
      <p>{{$route.meta.title}}</p>
      <van-button
        type="default"
        icon="clear"
        v-show="headerShow"
        @click="closeHandsel"
      >退出</van-button>
    </header>
  </div>
</template>

<script>
export default {
  name: "h5Header",
  props: {
    headerShow: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    closeHandsel() {
      // url有值时路由跳转
      if (this.$route.meta.headerBack) {
        if (this.$store.getters.ambientType == 1) {
          window.Android.closeHandsel();
        } else if (this.$store.getters.ambientType == 2) {
          window.webkit.messageHandlers.closeHandsel.postMessage("");
        }
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.headercontent {
  height: 44px;
  position: relative;
  text-align: center;
  header {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 2000;
    width: 100%;
    height: 44px;
    background: #fff;
    .return {
      font-size: 26px;
      position: absolute;
      left: 6px;
      z-index: 88;
      height: 44px;
      line-height: 44px;
      color: #606060;
    }
    p {
      font-size: 17px;
      margin: 0;
      position: absolute;
      left: 0;
      right: 0;
      top: 10px;
      z-index: 87;
    }
    .van-button {
      width: 49px;
      height: 25px;
      padding: 0;
      border-radius: 16px;
      position: absolute;
      right: 15px;
      z-index: 88;
      i {
        color: #999;
        font-size: 16px;
      }
      .van-button__text {
        font-size: 12px;
        margin-left: 2px;
      }
    }
  }
}
</style>

